import { render, staticRenderFns } from "./TravelAdvisorPage.vue?vue&type=template&id=69c34fa4&scoped=true&"
import script from "./TravelAdvisorPage.vue?vue&type=script&lang=js&"
export * from "./TravelAdvisorPage.vue?vue&type=script&lang=js&"
import style0 from "./TravelAdvisorPage.vue?vue&type=style&index=0&id=69c34fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c34fa4",
  null
  
)

export default component.exports